import { ControlValueAccessor } from "@angular/forms";
import { OnChanges, SimpleChanges, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

export class ValueAccessorBase<T>
	implements ControlValueAccessor, OnChanges, OnDestroy {
	private _innerValue: T;

	private _isDisabled: boolean;
	private _changed = new Array<(value: T) => void>();
	private _touched = new Array<() => void>();
	protected destroy$: Subject<boolean> = new Subject();

	get disabledState(): boolean {
		return this._isDisabled;
	}

	get innerValue(): T {
		return this._innerValue;
	}

	set innerValue(val: T) {
		this._innerValue = val;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes && changes.disabled) {
			this.setDisabledState(changes.disabled.currentValue);
		}

		if (changes && changes.isDisabled) {
			this.setDisabledState(changes.isDisabled.currentValue);
		}
	}

	ngOnDestroy() {
		this.destroy$.next(true);
		this.destroy$.complete();
	}

	setModel(value: T) {
		if (this.innerValue !== value) {
			this.innerValue = value;
			this.changed(value);
		}
	}

	changed(value: T) {
		this._changed.forEach(f => f(value));
	}

	touch() {
		this._touched.forEach(f => f());
	}

	writeValue(value: T) {
		this.innerValue = value;
	}

	registerOnChange(fn: (value: T) => void) {
		this._changed.push(fn);
	}

	registerOnTouched(fn: () => void) {
		this._touched.push(fn);
	}

	setDisabledState?(isDisabled: boolean): void {
		this._isDisabled = isDisabled;
	}
}
